<template>
  <div>
    <div class="SecurityGroup-title">
      <div>{{$t('RAM.AWS.DMS.serverlessReplications')}}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:dms:serverless:update'
          ]"
          :loading="loading"
          @click="update"
        >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:dms:serverless:export'
          ]"
        >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="SecurityGroup-top">
      <sr-search
        ref="srSearchChild"
      ></sr-search>
    </div>
    <table-sr></table-sr>
  </div>
</template>

<script>
import SrSearch from "../serverlessReplications/SRSearch";
import TableSr from "../serverlessReplications/TableSR";

export default {
  name: "Sr",
  components: {
    SrSearch,
    TableSr
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: "",
      accountName: "",
      replicationConfigIdentifier: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.srSearchChild.companyId;
      this.$api.cmdb
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 34
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('RAM.AWS.ECS.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountName = this.$refs.srSearchChild.accountName;
      this.replicationConfigIdentifier = this.$refs.srSearchChild.name;
      this.companyId = this.$refs.srSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('RAM.AWS.ECS.pleaseWait')
      });
      // 下载Excel 文件
      this.$api.cmdb
        .exportAwsDmsServerlessReplication({
          accountName: this.accountName,
          companyId: this.companyId,
          replicationConfigIdentifier: this.replicationConfigIdentifier
        })
        .then(res => {
          let fileName = "Serverless.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('RAM.AWS.ECS.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.SecurityGroup-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.SecurityGroup-title > div:nth-child(1) {
  float: left;
}
.SecurityGroup-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.SecurityGroup-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/dms/serverlessReplications/serverlessReplications.vue